import React, { useState, useEffect } from 'react';

const Notepad: React.FC = () => {
  const [content, setContent] = useState('Loading...');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch('/api/content/about');
      const data = await response.json();
      setContent(data.content || 'No content yet. Add content via the admin panel.');
    } catch (error) {
      console.error('Error fetching content:', error);
      setContent('Error loading content.');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{
        background: '#c0c0c0',
        borderBottom: '2px solid #808080',
        padding: '2px 4px',
        display: 'flex',
        gap: '8px'
      }}>
        <div style={{ fontSize: '11px', padding: '2px 8px' }}>
          <u>F</u>ile
        </div>
        <div style={{ fontSize: '11px', padding: '2px 8px' }}>
          <u>E</u>dit
        </div>
      </div>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        readOnly={!isEditing}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          padding: '8px',
          fontFamily: '"Courier New", monospace',
          fontSize: '13px',
          resize: 'none',
          background: '#fff',
        }}
      />
    </div>
  );
};

export default Notepad;
